<template>
  <div class="container">
    <div class="topContainer">
      <SupportProdNoDialog
        :visible.sync="supportProdNoDialogVisible"
        :supportProducts="form.supportProducts"
        @sure="sureSupportProdNo"
      />
      <UnSelectSubDeviceListDialog
        :visible.sync="unSelectSubDeviceListDialogVisible"
        :subDeviceIds="form.subDeviceIds"
        :deviceId="deviceId"
        :isEdit="isEdit"
        @sure="sureSelectSubDevice"
      />
      <div style="position: relative; width: 100%">
        <div
          style="display: flex; flex-direction: row; align-items: center; width: 100%; justify-content: space-between">
          <h4 class="title" style="flex: 8;">{{ isEdit ? $t('device.editDevice') : $t('device.addNewDevice') }}</h4>
          <div style="flex: 2;">
            <el-button v-if="isEdit && deviceDetailInfo" size="mini" class="orange-button" @click="printDeviceLabel">
              {{ $t('common.printLabel') }}
            </el-button>
            <el-button v-if="isEdit" :loading="loading" type="danger" size="mini" @click="deleteDevice">
              {{ $t('common.delete') }}
            </el-button>
          </div>
        </div>
        <div class="separator"></div>
        <div class="info-container">
          <el-form size="small" :model="form" style="width: 87%;" ref="refForm" :rules="rules" label-width="180px">
            <el-form-item label-width="0">
              <el-col :span="12">
                <el-form-item :label="$t('common.deviceCategory') + ':'" prop="deviceCategory">
                  <el-select
                    v-model="form.deviceCategory"
                    clearable
                    filterable
                    size="small"
                    style="width: 100%;">
                    <el-option
                      v-for="item in defaultCategoryTypes"
                      :key="item.value"
                      :label="item.explain"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('common.address') + ':'" prop="address">
                  <el-input
                    v-model.trim="form.address"
                    name="address"
                    type="text"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="255"
                  />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="12">
                <el-form-item :label="$t('common.deviceName') + ':'" prop="deviceName">
                  <el-input
                    v-model.trim="form.deviceName"
                    name="deviceName"
                    type="text"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('common.deviceModel') + ':'" prop="deviceModel">
                  <el-input
                    v-model.trim="form.deviceModel"
                    name="deviceModel"
                    type="text"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="12">
                <el-form-item :label="$t('common.deviceNumber') + ':'" prop="deviceNumber">
                  <el-input
                    v-model.trim="form.deviceNumber"
                    name="deviceNumber"
                    type="text"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('common.productionDate') + ':'" prop="productionDate">
                  <el-date-picker
                    v-model="form.productionDate"
                    type="date"
                    size="small"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="12">
                <el-form-item :label="$t('common.installDate') + ':'" prop="installDate">
                  <el-date-picker
                    v-model="form.installDate"
                    type="date"
                    size="small"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('common.softwareVersion') + ':'" prop="softwareVersion">
                  <el-input
                    v-model.trim="form.softwareVersion"
                    name="softwareVersion"
                    type="text"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="12">
                <el-form-item :label="$t('common.supportProducts') + ':'" prop="supportProducts">
                  <el-input
                    :value="supportProductsVal"
                    name="supportProducts"
                    type="text"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="255"
                    @focus="focusSupportProducts"
                    @clear="clearSupportProducts"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('common.status') + ':'" prop="status">
                  <el-select
                    v-model="form.status"
                    clearable
                    filterable
                    size="small"
                    style="width: 100%;">
                    <el-option
                      v-for="item in defaultDeviceStatus"
                      :key="item.value"
                      :label="item.explain"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="12">
                <el-form-item :label="$t('common.testReport') + ':'" prop="testReport">
                  <el-upload
                    :headers="headers"
                    :action="actionTestReport"
                    :on-success="handleSuccessTestReport"
                    :on-remove="handleRemoveTestReport"
                    :before-upload="handleBeforeUpload"
                    :on-error="handleError"
                    :on-preview="handlerPreviewTestReport"
                    :on-exceed="handlerExceedTestReport"
                    :limit="1"
                    :file-list="fileListTestReport"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
                    <el-button size="small" type="plain">{{ $t('incomingOrder.upload') }}</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="24">
                <el-form-item :label="$t('common.comment') + ':'">
                  <el-input
                    v-model="form.comment"
                    name="comment"
                    type="textarea"
                    autocomplete="on"
                    clearable
                    size="small"
                    maxlength="255"
                    :rows="3"
                    show-word-limit>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0" style="margin-bottom: 0;">
              <h4 style="color: #169BD5;">{{ $t('common.component') }}</h4>
            </el-form-item>
            <el-form-item label-width="0" prop="deviceIds">
              <el-col :span="24" style="margin: 20px 0 0;">
                <el-table
                  ref="table"
                  border
                  max-height="400"
                  :data="subDevices"
                  :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
                  :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
                  header-cell-class-name="headerCellName">
                  <el-table-column prop="addr" :label="$t('common.address')"/>
                  <el-table-column prop="deviceName" :label="$t('common.deviceName')"/>
                  <el-table-column prop="deviceModel" :label="$t('common.deviceModel')"/>
                  <el-table-column prop="deviceNo" :label="$t('common.deviceNumber')"/>
                  <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                    <template slot-scope="scope">
                      {{formatDate(scope.row.productionDate)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
                  <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
                  <el-table-column prop="status" :label="$t('common.status')">
                    <template slot-scope="scope">
                      {{subDeviceStatusVal(scope.row)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
                  <el-table-column width="80" :label="$t('common.operate')">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        class="link"
                        @click="deleteSubDevice(scope.row, scope.$index)">
                        {{$t('common.delete')}}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0" style="margin: 10px 0">
              <el-button
                class="orange-button"
                icon="el-icon-plus"
                @click="addSubDevice"
                circle>
              </el-button>
            </el-form-item>>
          </el-form>
        </div>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button :loading="loading" size="small" type="primary" @click="submitForm">
          {{ isEdit ? $t('common.update') : $t('common.save') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  deviceAdd,
  deviceUpdate,
  deviceDelete,
  devicesList,
} from '@/api/device';
import SupportProdNoDialog from '../components/SupportProdNoDialog';
import UnSelectSubDeviceListDialog from '../components/UnSelectSubDeviceListDialog';
import {isValueEmpty, remove_ie_header_and_footer} from "@/utils";
import moment from "moment";
import {mapGetters} from "vuex";
import {initDeviceLabel} from "@/utils/deviceLabel";
import {
  defaultCategoryTypes,
  defaultDeviceStatus,
  defaultSubDeviceStatus,
} from '@/utils/defines';

const defaultForm = {
  deviceCategory: undefined,
  address: undefined,
  deviceName: undefined,
  deviceModel: undefined,
  deviceNumber: undefined,
  productionDate: undefined,
  installDate: undefined,
  softwareVersion: undefined,
  supportProducts: undefined,
  subDeviceIds: undefined,
  testReport: undefined,
  status: 1,
  comment: undefined,
};

export default {
  name: "deviceDetail",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SupportProdNoDialog,
    UnSelectSubDeviceListDialog,
  },
  data() {
    return {
      form: {...defaultForm, deviceNumber: this.createDeviceNumber()},
      rules: {
        deviceCategory: [{required: true, trigger: 'change', message: this.$t('validate.deviceCategoryCanNotBeEmpty')}],
        address: [{required: true, trigger: 'change', message: this.$t('validate.addressCanNotBeEmpty')}],
        deviceName: [{required: true, trigger: 'change', message: this.$t('validate.deviceNameCanNotBeEmpty')}],
        deviceModel: [{required: true, trigger: 'change', message: this.$t('validate.deviceModelCanNotBeEmpty')}],
        deviceNumber: [{required: true, trigger: 'change', message: this.$t('validate.deviceNumberCanNotBeEmpty')}],
        productionDate: [{required: true, trigger: 'change', message: this.$t('validate.productionDateCanNotBeEmpty')}],
        status: [{required: true, trigger: 'change', message: this.$t('validate.statusCanNotBeEmpty') }],
      },
      loading: false,
      defaultCategoryTypes,
      defaultDeviceStatus,
      fileList: [],
      tempRoute: {},
      deviceId: undefined,
      subDevices: [],
      supportProdNoDialogVisible: false,
      fileListTestReport: [],
      deviceDetailInfo: undefined,
      unSelectSubDeviceListDialogVisible: false,
      from: undefined,
    };
  },
  computed: {
    ...mapGetters([
      'token',
    ]),
    headers() {
      return {
        Authorization: `Bearer ${this.token}`,
      };
    },
    actionTestReport() {
      return '/api/v1/files/testReport';
    },
    supportProductsVal() {
      const {
        supportProducts,
      } = this.form;
      if (isValueEmpty(supportProducts)) {
        return '';
      }
      let val = [];
      for (let row of supportProducts) {
        val.push(`${row.prod}:${row.testDaily}K`);
      }
      return val.join(';');
    },
  },
  mounted() {
    if (this.isEdit) {
      this.deviceId = this.$route.params && this.$route.params.deviceId;
      this.from = this.$route.query && this.$route.query.from;
      this.deviceDetail();
    }
    this.tempRoute = Object.assign({}, this.$route);
  },
  methods: {
    async deviceDetail() {
      try {
        const res = await devicesList({
          id: this.deviceId,
          flag: [1, 2, 3]
        });
        const {data} = res;
        const devices = data.records || [];
        if (devices.length === 0) {
          this.$message({
            type: 'error',
            message: this.$t('device.deviceInfoMissing'),
          });
          return;
        }
        this.deviceDetailInfo = devices[0];
        const {
          flag,
          addr,
          deviceName,
          deviceModel,
          deviceNo,
          productionDate,
          softwareVersion,
          status,
          installationDate,
          comment,
          testReport,
          supportProduct,
          subDevice,
        } = devices[0];
        let support = undefined;
        if (!isValueEmpty(supportProduct) && supportProduct) {
          try {
            support = JSON.parse(supportProduct);
          } catch (e) {
            // do nothing.
          }
        }
        let testReportVal;
        if (testReport) {
          try {
            testReportVal = JSON.parse(testReport);
            this.fileListTestReport = [];
            for (let row of testReportVal) {
              this.fileListTestReport.push({
                name: row,
                url: this.attachmentUrl(row, 'testReport'),
              });
            }
          } catch (e) {
            // do nothing.
          }
        }
        let subDeviceIdsVal = [];
        if (subDevice && subDevice.length > 0) {
          subDeviceIdsVal = subDevice.map(item => item.id);
        }
        this.form = {
          deviceCategory: flag,
          address: addr,
          deviceName: deviceName,
          deviceModel: deviceModel,
          deviceNumber: deviceNo,
          productionDate: productionDate,
          installDate: installationDate,
          softwareVersion: softwareVersion,
          supportProducts: support,
          subDeviceIds: subDeviceIdsVal,
          testReport: testReportVal,
          status: status,
          comment: comment,
        };
        this.devicesList();
      } catch (e) {
        // do nothing.
      }
    },
    deleteDevice() {
      this.$confirm(this.$t('device.thisActionWillDeleteThisDevice'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          deviceId
        } = this;
        this.loading = true;
        try {
          await deviceDelete({
            ids: [deviceId],
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.backOrderListPage();
        } catch (e) {
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        // do nothing.
      });
    },
    handleBeforeUpload(file) {
      const isLessThan2M = file.size / 1024 / 1024 < 2;
      if (!isLessThan2M) {
        this.$message({
          type: 'error',
          message: this.$t('common.sizeNotExceed2M'),
        });
      }
      return isLessThan2M;
    },
    handleSuccessTestReport(response, file) {
      this.form.testReport = [file.name];
      this.$message({
        type: 'success',
        message: this.$t('common.uploadSuccess'),
      });
    },
    handleError() {
      this.$message({
        type: 'error',
        message: this.$t('common.uploadFailure'),
      });
    },
    handleRemoveTestReport() {
      this.form.testReport = undefined;
    },
    handlerPreviewTestReport(file) {
      const url = this.attachmentUrl(file.name, 'testReport');
      window.open(url, 'blank');
    },
    attachmentUrl(attachment, file) {
      return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/${file}/${attachment}`;
    },
    handlerExceedTestReport() {
      this.$message({
        type: 'error',
        message: this.$t('device.aDeviceCanOnlyHaveAtMostOneTestReport'),
      });
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (this.isEdit) {
            this.deviceUpdate();
          } else {
            this.deviceAdd();
          }
        }
      });
    },
    async deviceUpdate() {
      const {
        deviceCategory,
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        productionDate,
        installDate,
        softwareVersion,
        supportProducts,
        subDeviceIds,
        testReport,
        status,
        comment,
      } = this.form;
      this.loading = true;
      try {
        await deviceUpdate({
          id: this.deviceId,
          flag: deviceCategory,
          addr: address,
          deviceName: deviceName,
          deviceModel: deviceModel,
          deviceNo: deviceNumber,
          productionDate: productionDate,
          status: status,
          installationDate: installDate || undefined,
          softwareVersion: isValueEmpty(softwareVersion) ? undefined : softwareVersion,
          testReport: testReport && testReport.length > 0 ? JSON.stringify(testReport) : null,
          comment: isValueEmpty(comment) ? undefined : comment,
          supportProduct: supportProducts && supportProducts.length > 0 ? JSON.stringify(supportProducts) : null,
          subDeviceIds: subDeviceIds && subDeviceIds.length > 0 ? subDeviceIds : [],
        });
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
        this.backOrderListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async deviceAdd() {
      const {
        deviceCategory,
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        productionDate,
        installDate,
        softwareVersion,
        supportProducts,
        subDeviceIds,
        testReport,
        status,
        comment,
      } = this.form;
      this.loading = true;
      try {
        await deviceAdd({
          flag: deviceCategory,
          addr: address,
          deviceName: deviceName,
          deviceModel: deviceModel,
          deviceNo: deviceNumber,
          productionDate: productionDate,
          status: status,
          installationDate: installDate || undefined,
          softwareVersion: isValueEmpty(softwareVersion) ? undefined : softwareVersion,
          testReport: testReport && testReport.length > 0 ? JSON.stringify(testReport) : null,
          comment: isValueEmpty(comment) ? undefined : comment,
          supportProduct: supportProducts && supportProducts.length > 0 ? JSON.stringify(supportProducts) : undefined,
          subDeviceIds: subDeviceIds && subDeviceIds.length > 0 ? subDeviceIds : undefined,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.createSuccess'),
        });
        this.backOrderListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async devicesList() {
      try {
        const res = await devicesList({
          flag: [100, 100],
        });
        const {
          data,
        } = res;
        const records = data.records || [];
        this.subDevices = records.filter(item => {
          return item.deviceId === Number.parseFloat(this.deviceId);
        });
      } catch (e) {
        // do nothing.
      }
    },
    focusSupportProducts() {
      this.supportProdNoDialogVisible = true;
    },
    clearSupportProducts() {
      this.form.supportProducts = undefined;
    },
    backOrderListPage() {
      if (this.from === 'subDevice') {
        this.$router.replace({path: '/asset-management/subDevice'});
      } else {
        this.$router.replace({path: '/asset-management/device'});
      }
      this.$store.dispatch('tagsView/delView', this.tempRoute);
    },
    sureSupportProdNo(val) {
      this.form.supportProducts = val;
    },
    sureSelectSubDevice(subDevices) {
      if (subDevices && subDevices.length > 0) {
        this.subDevices = this.subDevices.concat(subDevices);
        let selectSubDeviceIds = subDevices.map(item => item.id);
        if (this.form.subDeviceIds) {
          this.form.subDeviceIds = this.form.subDeviceIds.concat(selectSubDeviceIds);
        } else {
          this.form.subDeviceIds = selectSubDeviceIds;
        }
      }
    },
    createDeviceNumber() {
      let str = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
      let n = 4;
      let s = '';
      let rand = '';
      let length = str.length;
      for (let i = 0; i < n; i++) {
        rand = Math.floor(Math.random() * length);
        s += str.charAt(rand);
      }
      return 'WC' + moment().format('YYMM') + s;
    },
    printDeviceLabel() {
      let iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      const {
        deviceDetailInfo,
      } = this;
      iframe = initDeviceLabel({
        iframe, ...deviceDetailInfo,
        company: '网策科技有限公司',
      });
      setTimeout(() => {
        if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
          remove_ie_header_and_footer();
        }
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
        iframe = null;
      }, 200);
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    deleteSubDevice(row, index) {
      const findIndex = this.form.subDeviceIds.findIndex(item => item === row.id);
      if (findIndex !== -1) {
        this.form.subDeviceIds.splice(findIndex, 1);
        this.subDevices.splice(index, 1);
      }
    },
    addSubDevice() {
      this.unSelectSubDeviceListDialogVisible = true;
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}

.separator {
  width: 100%;
  height: 1px;
  background: #E5E5E5;
  display: block;
}

.title {
  margin: 10px 20px;
  font-size: 16px;
  color: #555555;
}

.info-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
}
.orange-button {
  background: #FF8605;
  color: white;
  border: 0;
}
.control-container {
  background: #F5F5F5;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
}
.topContainer {
  height: 100%;
  overflow: auto;
  flex: 1;
}
</style>
